module.exports = function() {
  return new Worker(__webpack_public_path__ + "99e42d14199228686e7e.worker.js");
};